import { Pipe, PipeTransform } from '@angular/core';
import { Office, Branch, City, Agent, Company } from '../models/missingdata.model';


@Pipe({
  name: 'tablesFilter'
})
export class TablesFilterPipe implements PipeTransform {

  transform(ListDatos: any, searchTerm: string) {    
    if (!ListDatos || !searchTerm ) {
      return ListDatos;
    }
    if (ListDatos[0].hasOwnProperty('configValue')) {
      return ListDatos.filter((Item: Company) =>
        Item.configValue.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
    if (ListDatos[0].hasOwnProperty('branchName')) {
      return ListDatos.filter((Item: Branch) =>
        Item.branchName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
    if (ListDatos[0].hasOwnProperty('cityName')) {
      return ListDatos.filter((Item: City) =>
        Item.cityName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
    if (ListDatos[0].hasOwnProperty('officeName')) {
      return ListDatos.filter((Item: Office) =>
        Item.officeName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
    if (ListDatos[0].hasOwnProperty('agentName')) {
      return ListDatos.filter((Item: Agent) =>
        Item.agentName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }
  }

}
